import noObserve from 'src/mixins/noObserve';

// import _get for use in templates
export default async ({ Vue }) => {
  Vue.mixin(noObserve);
};
